<template>
    <div class="checkRebate">

        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="返点类型：" v-if="curRole=='admin'||curRole=='sales'">
                    <el-radio-group v-model.trim="curType" @change="typeChange">
                        <el-radio v-for="item in typeList" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
                    </el-radio-group>
                    <el-date-picker
                        style="width:120px"
                        @change="search"
                        format="YYYY-MM"
                        value-format="YYYYMM"
                        v-model="formInline.month"
                        type="month"
                        placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="日期：" v-if="curRole=='agent'">
                    <el-date-picker
                        style="width:120px"
                        @change="search"
                        format="YYYY-MM"
                        value-format="YYYYMM"
                        v-model="formInline.month"
                        type="month"
                        placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="地区：">
                    <el-select v-model="formInline.region" clearable style="width:120px" @change="search" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in regionList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Payers：">
                    <el-select v-model="formInline.payer_id" clearable filterable style="width:120px" @change="search" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in payersList"
                            :key="index"
                            :label="item.name+'('+item.payer_id+')'"
                            :value="item.payer_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="账号类型：">
                    <el-select v-model="formInline.account_type" clearable style="width:130px" @change="search" placeholder="全部">
                        <el-option label="Normal" value="normal"></el-option>
                        <el-option label="Billing Transfer" value="bt"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售：" v-if="curRole=='admin'">
                    <el-select clearable filterable v-model.trim="formInline.sales" placeholder="请选择" @change="search" style="width:120px">
                        <el-option
                            v-for="item in salesList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合作伙伴：" v-if="curRole=='admin'||curRole=='sales'">
                    <el-select clearable filterable v-model.trim="formInline.agent_id" placeholder="请选择" @change="search" style="width:120px">
                        <el-option
                            v-for="item in agentsList"
                            :key="item.agent_id"
                            :label="item.company"
                            :value="item.agent_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户：">
                    <el-select v-model="formInline.customer" clearable filterable style="width:120px" @change="search" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in customersList"
                            :key="index"
                            :label="item.company"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="LinkId：">
                    <el-select v-model="formInline.link_id" clearable filterable style="width:120px;" @change="search" placeholder="请选择"
                      :filter-method="linkFilterMethod">
                        <el-option v-for="item in displayedLinksList" :key="item.link_id"
                          :label="(item.customer_name || item.name || item.link_id) + '（' + item.link_id + '）'"
                          :value="item.link_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=""><el-button  @click="search" icon="Search" style="background:#1a1a2e;border-color:#1a1a2e;color:#fff;border-radius:8px;">查询</el-button></el-form-item>
                <el-form-item label=""><el-button  @click="reset" icon="Refresh">重置</el-button></el-form-item>
            </el-form>
        </div>
        <div class="table-wrapper">
            <div class="batch-actions" style="padding: 10px 0; padding-left: 16px; background: #fff; border-bottom: 1px solid #ebeef5;">
                <el-button size="small" @click="openBatchEdit" style="background:#86868b;border-color:#86868b;color:#fff;border-radius:8px;">
                    <el-icon><Edit /></el-icon>
                    批量修改返点
                </el-button>
            </div>
            <div class="table">
                <el-table height="450" :row-class-name="tableRowClassName" @sort-change="sortChange" stripe :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%;">
                <el-table-column label="LinkerId" min-width="120" align="center">
                    <template #default="scope">
                        {{scope.row.linkId}}
                    </template>
                </el-table-column>
                <el-table-column label="Link名称" min-width="90" align="center">
                    <template #default="scope">
                        <span>{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="PayerName" min-width="150" align="center">
                    <template #default="scope">
                        {{ scope.row.payer }}
                    </template>
                </el-table-column>
                <el-table-column label="账单实体" min-width="60" align="center">
                    <template #default="scope">
                        {{ scope.row.entity }}
                    </template>
                </el-table-column>
                <el-table-column label="VAP返点" sortable min-width="80" align="center" v-if="curRole=='admin'||curRole=='sales'">
                    <template #default="scope">
                        {{ (Number(scope.row.discount1)*100).toFixed(0)+'%' }}
                    </template>
                </el-table-column>
                <el-table-column label="伙伴返点" sortable min-width="80" align="center">
                    <template #default="scope">
                        {{(Number(scope.row.discount2)*100).toFixed(1)+'%'}}
                    </template>
                </el-table-column>
                <el-table-column label="客户返点" min-width="80" align="center">
                    <template #default="scope">
                        {{ (Number(scope.row.discount3)*100).toFixed(1)+'%' }}
                    </template>
                </el-table-column>
                <el-table-column label="Credit抵扣方式" align="center" min-width="110">
                    <template #default="scope">
                        <el-tag :type="scope.row.creditDeductionMethod === 'before' ? 'warning' : 'success'" size="small">
                            {{ scope.row.creditDeductionMethod === 'before' ? '先抵' : '后抵' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="截止日期" align="center" v-if="curType==1&&curRole!='agent'">
                    <template #default="scope">
                       {{ scope.row.monthEnd.toString().replace(/^(\d{4})(\d{2})$/, "$1-$2") }}
                    </template>
                </el-table-column>
                <el-table-column label="说明" align="center" v-if="curType==1&&curRole!='agent'">
                    <template #default="scope">
                        <span v-if="Number(scope.row.monthEnd.toString().substring(0,4)) == curYear &&Number(scope.row.monthEnd.toString().substring(4,6)) == curMonth">新用户返点即将到期</span>
                        <span v-if="Number(scope.row.monthEnd.toString().substring(0,4)) == curYear &&Number(scope.row.monthEnd.toString().substring(4,6)) == (curMonth - 1)">新用户返点已到期</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" min-width="50" align="center">
                    <template #default="scope">
                        <el-button size="small" link type="primary" @click="edit(scope.row)" icon="Edit"></el-button>
                    </template>
                </el-table-column>
                </el-table>
            </div>
            <div class="pagination-wrapper" style="padding: 15px 0; text-align: center;">
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
            </div>
        </div>
        <!-- 批量修改弹窗 -->
        <el-dialog v-model="batchDialogVisible" :close-on-click-modal="false" :before-close="cancelBatch" width="900">
            <template #header>
                <span style="font-size:18px;">批量修改返点</span>
            </template>
            <div style="display: flex; gap: 20px;">
                <!-- 左侧选择区 -->
                <div style="flex: 1; border-right: 1px solid #ebeef5; padding-right: 20px;">
                    <el-form label-width="100px" label-position="left">
                        <el-form-item label="选择伙伴" v-if="curRole=='admin'||curRole=='sales'">
                            <el-select v-model="batchSelectedAgent" filterable placeholder="请选择伙伴" @change="onBatchAgentChange" style="width: 100%;">
                                <el-option v-for="item in agentsList" :key="item.agent_id" :label="item.company" :value="item.agent_id"></el-option>
                            </el-select>
                        </el-form-item>

                        <div style="margin-bottom: 15px;">
                            <div style="margin-bottom: 5px; font-size: 14px; color: #606266;">选择Payer</div>
                            <el-checkbox v-model="batchSelectAllPayers" @change="onSelectAllPayers" style="margin-bottom: 10px;">全选</el-checkbox>
                            <div style="max-height: 150px; overflow-y: auto;">
                                <el-checkbox-group v-model="batchSelectedPayers" @change="onBatchPayerChange">
                                    <div v-for="payer in batchPayerOptions" :key="payer.payer_id" style="margin-bottom: 8px;">
                                        <el-checkbox :label="payer.payer_id">{{ payer.name }}</el-checkbox>
                                    </div>
                                </el-checkbox-group>
                            </div>
                        </div>

                        <!-- 仅当选中的 payer 里有 BT payer 时出现：按二代PMA自有树 / CMA 树圈定 Link -->
                        <div v-if="batchCmaOptions.length" style="margin-bottom: 15px;">
                            <div style="margin-bottom: 5px; font-size: 14px; color: #606266;">
                                选择CMA
                                <span style="font-size: 12px; color: #909399;">（BT Payer，勾选后下方只列出并选中该CMA的Link）</span>
                            </div>
                            <el-checkbox v-model="batchSelectAllCmas" :indeterminate="batchCmaIndeterminate" style="margin-bottom: 10px;">全选</el-checkbox>
                            <div style="max-height: 160px; overflow-y: auto;">
                                <el-checkbox-group v-model="batchSelectedCmas" @change="onBatchCmaChange">
                                    <div v-for="g in batchCmaOptions" :key="g.key" style="margin-bottom: 8px;">
                                        <el-checkbox :label="g.key">
                                            <el-tag size="small" effect="plain" :type="g.kind === 'pma' ? 'warning' : 'success'" style="margin-right: 4px;">{{ g.kind === 'pma' ? '二代PMA' : 'CMA' }}</el-tag>{{ g.label }}
                                        </el-checkbox>
                                    </div>
                                </el-checkbox-group>
                            </div>
                        </div>

                        <el-form-item label="佳杰留利" v-if="curRole=='admin'||curRole=='sales'">
                            <div style="display: flex; gap: 10px; align-items: flex-start;">
                                <div style="flex: 1;">
                                    <el-input
                                        v-model="batchFormData.agentProfit"
                                        @input="handleAgentProfitChange"
                                        placeholder="输入留利后自动计算伙伴返点">
                                        <template #append>%</template>
                                    </el-input>
                                    <div style="font-size: 12px; color: #f56c6c; margin-top: 4px;">
                                        <el-icon><InfoFilled /></el-icon>
                                        设置后将更新选中Payer下所有Link的默认配置，未来生成新月份账单时会自动按此留利计算伙伴返点。伙伴返点 = VAP返点 - 留利
                                    </div>
                                </div>
                                <el-button type="primary" @click="applyAgentProfit" :disabled="!batchFormData.agentProfit" style="margin-top: 0;">
                                    设置
                                </el-button>
                            </div>
                        </el-form-item>
                        <div style="margin-bottom: 15px;">
                            <div style="margin-bottom: 5px; font-size: 14px; color: #606266;">选择Link</div>
                            <el-checkbox v-model="batchSelectAllLinks" @change="onSelectAllLinks" style="margin-bottom: 10px;">全选</el-checkbox>
                            <div style="max-height: 200px; overflow-y: auto;">
                                <el-checkbox-group v-model="batchSelectedLinks" @change="updateBatchLastMonthData">
                                    <div v-for="link in batchVisibleLinkOptions" :key="link.linkId" style="margin-bottom: 8px;">
                                        <el-checkbox :label="link.linkId">{{ link.linkId }} - {{ link.name }}</el-checkbox>
                                    </div>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </el-form>
                </div>
                <!-- 右侧修改区 -->
                <div style="flex: 1;">
                    <el-form label-width="120px">
                        <el-form-item label="月份">
                            <el-date-picker v-model="batchMonth" type="month" format="YYYY-MM" value-format="YYYYMM" placeholder="选择月份" style="width: 100%;"></el-date-picker>
                        </el-form-item>

                        <el-form-item label="VAP返点：" v-if="curRole=='admin'||curRole=='sales'">
                            <el-input v-model="batchFormData.discount1" readonly disabled>
                                <template #append>%</template>
                            </el-input>
                            <div style="font-size: 12px; color: #909399; margin-top: 4px;">
                                当前选中Link的VAP返点（只读）
                            </div>
                        </el-form-item>

                        <el-form-item label="伙伴返点：" v-if="curRole=='admin'||curRole=='sales'">
                            <el-input
                                v-model="batchFormData.discount2"
                                @input="(v)=>(batchFormData.discount2=v.replace(/[^\d.]/g,''))"
                                :placeholder="batchLastMonthData.discount2"
                                :disabled="!!batchFormData.agentProfit">
                                <template #append>%</template>
                            </el-input>
                            <div v-if="batchFormData.agentProfit" style="font-size: 12px; color: #909399; margin-top: 4px;">
                                已通过留利自动计算
                            </div>
                        </el-form-item>
                        <el-form-item label="客户返点：">
                            <el-input v-model="batchFormData.discount3" @input="(v)=>(batchFormData.discount3=v.replace(/[^\d.]/g,''))" :placeholder="batchLastMonthData.discount3"><template #append>%</template></el-input>
                        </el-form-item>
                        <el-form-item label="伙伴服务返点：" v-if="curRole=='admin'||curRole=='sales'">
                            <el-input v-model="batchFormData.sb_discount2" @input="(v)=>(batchFormData.sb_discount2=v.replace(/[^\d.]/g,''))" :placeholder="batchLastMonthData.sb_discount2"><template #append>%</template></el-input>
                        </el-form-item>
                        <el-form-item label="客户服务返点：">
                            <el-input v-model="batchFormData.sb_discount3" @input="(v)=>(batchFormData.sb_discount3=v.replace(/[^\d.]/g,''))" :placeholder="batchLastMonthData.sb_discount3"><template #append>%</template></el-input>
                        </el-form-item>
                        <el-form-item label="是否屏蔽Credit：">
                            <el-radio-group v-model="batchFormData.credit">
                                <el-radio :label="1" size="small">是</el-radio>
                                <el-radio :label="0" size="small">否</el-radio>
                                <el-radio :label="-1" size="small">不修改</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="是否屏蔽RI：">
                            <el-radio-group v-model="batchFormData.ri">
                                <el-radio :label="1" size="small">是</el-radio>
                                <el-radio :label="0" size="small">否</el-radio>
                                <el-radio :label="-1" size="small">不修改</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="是否屏蔽SP：">
                            <el-radio-group v-model="batchFormData.sp">
                                <el-radio :label="1" size="small">是</el-radio>
                                <el-radio :label="0" size="small">否</el-radio>
                                <el-radio :label="-1" size="small">不修改</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="是否屏蔽Bundle：">
                            <el-radio-group v-model="batchFormData.bundle">
                                <el-radio :label="0" size="small">否(0)</el-radio>
                                <el-radio :label="1" size="small">仅屏蔽客户(1)</el-radio>
                                <el-radio :label="2" size="small">均屏蔽(2)</el-radio>
                                <el-radio :label="-1" size="small">不修改</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <template #footer>
                <div style="text-align: right;">
                    <span v-if="batchSubmitting && batchProgress.total" style="margin-right: 10px; color: #409eff;">
                        正在保存 {{ batchProgress.done }}/{{ batchProgress.total }}<span v-if="batchProgress.failed" style="color: #f56c6c;">，失败 {{ batchProgress.failed }}</span>
                    </span>
                    <span v-else style="margin-right: 10px; color: #909399;">已选择 {{ batchSelectedLinks.length }} 个Link</span>
                    <el-button @click="cancelBatch" :disabled="batchSubmitting">取消</el-button>
                    <el-button type="primary" @click="submitBatch" :loading="batchSubmitting">确定修改</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 单个修改弹窗 -->
        <el-dialog v-model="dialogVisible" :close-on-click-modal="false" :before-close="cancel" :width="curRole=='agent'?'650':'1000'">
            <div slot="title" class='zkTitle' style="position:absolute;top:23px;">
                <span style="font-size:18px;">修改返点 </span>
                <span v-if="curType == 2" style="font-size:18px;">- {{formInline.month}}</span>
                <span v-if="curType == 1" style="font-size:18px;">- 默认日期</span>
            </div>
            <el-form :inline="false" :model="formData" ref="rulesForm" label-position="right" label-width="auto">
                <el-row v-if="curRole=='admin'||curRole=='sales'">
                    <el-col :span="8">
                        <el-form-item label="VAP返点：" prop="discount1">
                            <el-input v-model="formData.discount1" readonly disabled><template #append>%</template></el-input>
                            <div style="font-size: 12px; color: #909399; margin-top: 4px;">由系统按 CUR 计算，不可修改</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="伙伴返点：" prop="discount2">
                            <el-input v-model="formData.discount2" @input="(v)=>(formData.discount2=v.replace(/[^\d.]/g,''))" placeholder="请输入小数点后两位，如0.25"><template #append>%</template></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="客户返点：" prop="discount3">
                            <el-input v-model="formData.discount3" @input="(v)=>(formData.discount3=v.replace(/[^\d.]/g,''))" placeholder="请输入小数点后两位，如0.25"><template #append>%</template></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="curRole=='admin'||curRole=='sales'">
                    <el-col :span="8">
                        <el-form-item label="VAP服务返点：" prop="discount1">
                            <el-input v-model="formData.sb_discount1" readonly disabled @input="(v)=>(formData.sb_discount1=v.replace(/[^\d.]/g,''))"><template #append>%</template></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="伙伴服务返点：" prop="sb_discount2">
                            <el-input v-model="formData.sb_discount2" @input="(v)=>(formData.sb_discount2=v.replace(/[^\d.]/g,''))" placeholder="请输入小数点后两位，如0.25"><template #append>%</template></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="客户服务返点：" prop="sb_discount3">
                            <el-input v-model="formData.sb_discount3" @input="(v)=>(formData.sb_discount3=v.replace(/[^\d.]/g,''))" placeholder="请输入小数点后两位，如0.25"><template #append>%</template></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="curRole=='admin'||curRole=='sales'">
                    <el-col :span="8">
                        <el-form-item label="是否屏蔽Credit：" prop="credit">
                            <el-radio-group v-model="formData.credit">
                                <el-radio :label="1" size="small">是</el-radio>
                                <el-radio :label="0" size="small">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="是否屏蔽RI：" prop="ri">
                            <el-radio-group v-model="formData.ri">
                                <el-radio :label="1" size="small">是</el-radio>
                                <el-radio :label="0" size="small">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="是否屏蔽SP：" prop="sp">
                            <el-radio-group v-model="formData.sp">
                                <el-radio :label="1" size="small">是</el-radio>
                                <el-radio :label="0" size="small">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="curRole=='admin'||curRole=='sales'">
                    <el-col :span="8">
                        <el-form-item label="是否屏蔽Bundle：" prop="bundle">
                            <el-radio-group v-model="formData.bundle">
                                <el-radio :label="0" size="small">否</el-radio>
                                <el-radio :label="1" size="small">仅屏蔽客户</el-radio>
                                <el-radio :label="2" size="small">均屏蔽</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" v-if="curType==1&&(curRole=='admin'||curRole=='sales')">
                        <el-form-item label="截止日期：" prop="monthEnd">
                            <el-date-picker
                                format="YYYY-MM"
                                value-format="YYYYMM"
                                v-model="formData.monthEnd"
                                type="month"
                                placeholder="选择截止日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row v-if="curRole=='agent'">
                    <el-col :span="12">
                        <el-form-item label="伙伴返点：" prop="discount2">
                            <el-input v-model="formData.discount2" readonly disabled @input="(v)=>(formData.discount2=v.replace(/[^\d.]/g,''))" placeholder="请输入小数点后两位，如0.25"><template #append>%</template></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="客户返点：" prop="discount3">
                            <el-input v-model="formData.discount3" @input="(v)=>(formData.discount3=v.replace(/[^\d.]/g,''))" placeholder="请输入小数点后两位，如0.25"><template #append>%</template></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="curRole=='agent'">
                    <el-col :span="12">
                        <el-form-item label="伙伴服务返点：" prop="sb_discount2">
                            <el-input v-model="formData.sb_discount2" readonly disabled @input="(v)=>(formData.sb_discount2=v.replace(/[^\d.]/g,''))" placeholder="请输入小数点后两位，如0.25"><template #append>%</template></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="客户服务返点：" prop="sb_discount3">
                            <el-input v-model="formData.sb_discount3" @input="(v)=>(formData.sb_discount3=v.replace(/[^\d.]/g,''))" placeholder="请输入小数点后两位，如0.25"><template #append>%</template></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="curRole=='agent'">
                    <el-col :span="12">
                        <el-form-item label="是否屏蔽Credit：" prop="credit">
                            <el-radio-group v-model="formData.credit">
                                <el-radio :label="1" size="small">是</el-radio>
                                <el-radio :label="0" size="small">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否屏蔽RI：" prop="ri">
                            <el-radio-group v-model="formData.ri">
                                <el-radio :label="1" size="small">是</el-radio>
                                <el-radio :label="0" size="small">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="curRole=='agent'">
                    <el-col :span="12">
                        <el-form-item label="是否屏蔽SP：" prop="sp">
                            <el-radio-group v-model="formData.sp">
                                <el-radio :label="1" size="small">是</el-radio>
                                <el-radio :label="0" size="small">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否屏蔽Bundle：" prop="bundle">
                            <el-radio-group v-model="formData.bundle">
                                <el-radio :label="0" size="small">否</el-radio>
                                <el-radio :label="1" size="small">仅屏蔽客户</el-radio>
                                <el-radio :label="2" size="small">均屏蔽</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <div style="display:flex;justify-content: space-between;align-items: center;">
                    <div class="left" style="color:#F56C6C;font-style:italic;">
                        <p v-if="curType==2">注：此处修改仅当月有效</p>
                        <p v-else>注：请确认该账户返点是否固定，此处修改下月至截止日期，返点将保持修改后的返点</p>
                    </div>
                    <div class="right">
                        <el-button @click="cancel()">取消</el-button>
                        <el-button type="primary" @click="submit">确定</el-button>
                    </div>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    import {getCheckRebateList,updateCheckRebate,getSalesList,getAgentList,getCustomerList,getPayerList,getLinkerList,getBtGroups} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    import Pagination from "@/components/Pagination";
    import { useBillDataStore } from '@/store/billData';
    import { Edit, InfoFilled } from '@element-plus/icons-vue';
    import { h } from 'vue';
    export default {
        components:{
            Pagination,
            Edit,
            InfoFilled
        },
        name:'checkRebate',
        data() {
            return {
                loadingPage:false,
                loading:false,
                tableHeight:500,
                formInline:{
                    month:0,
                    region:'',
                    sales:'',
                    agent_id:'',
                    payer_id:'',
                    link_id:'',
                    customer:'',
                    account_type:'',
                    orderby:'',
                    page: 1,
                    limit: 16,
                },
                curType:'2',
                typeList:[
                    {label:'日期',value:'2'},
                ],
                regionList:[
                    {label:'全部',value:''},
                    {label:'中国',value:'cn'},
                    {label:'Global',value:'global'}
                ],
                curYear:new Date().getFullYear(),
                curMonth:new Date().getMonth() + 1,
                curDate:'',
                salesList:[],
                agentsList:[],
                customersList:[],
                payersList:[],
                linksList:[],
                displayedLinksList:[],
                formData:{
                    discount1:'',
                    discount2:'',
                    discount3:'',
                    sb_discount2:'',
                    sb_discount3:'',
                    credit:0,
                    ri:0,
                    sp:0,
                    bundle:0,
                },
                dialogVisible:false,
                tableData:[],
                curRole:localStorage.getItem('curRole'),
                isDataLoaded: false,
                pageparm: {
                    page: 1,
                    limit: 16,
                    total: 0
                },
                // 批量修改相关
                batchDialogVisible: false,
                batchSubmitting: false,
                batchProgress: { done: 0, total: 0, failed: 0 },
                batchSelectedAgent: '',
                batchSelectedPayers: [],
                batchSelectAllPayers: false,
                batchSelectedLinks: [],
                batchSelectAllLinks: false,
                batchPayerOptions: [],
                batchLinkOptions: [],
                batchCmaOptions: [],     // [{key, kind, label, linkKeys:Set('payer|link')}]
                batchSelectedCmas: [],
                batchCmaReqSeq: 0,
                batchMonth: '',
                batchLastMonthData: {
                    discount2: '',
                    discount3: '',
                    sb_discount2: '',
                    sb_discount3: '',
                },
                batchFormData: {
                    discount1: '',
                    agentProfit: '',
                    discount2: '',
                    discount3: '',
                    sb_discount2: '',
                    sb_discount3: '',
                    credit: -1,
                    ri: -1,
                    sp: -1,
                    bundle: -1,
                },
            }
        },

        computed: {
            // CMA 全选：勾选=选中全部 CMA（下方 Link 随之全选），取消=清空
            batchSelectAllCmas: {
                get() {
                    return this.batchCmaOptions.length > 0 && this.batchSelectedCmas.length === this.batchCmaOptions.length;
                },
                set(val) {
                    this.batchSelectedCmas = val ? this.batchCmaOptions.map(g => g.key) : [];
                    this.onBatchCmaChange();
                },
            },
            batchCmaIndeterminate() {
                const n = this.batchSelectedCmas.length;
                return n > 0 && n < this.batchCmaOptions.length;
            },
            // 选了 CMA 时只列出这些 CMA 的 Link（按 payer|link 匹配，避免多 payer 串组）
            batchVisibleLinkOptions() {
                if (!this.batchSelectedCmas.length) return this.batchLinkOptions;
                const keys = new Set();
                this.batchCmaOptions
                    .filter(g => this.batchSelectedCmas.includes(g.key))
                    .forEach(g => g.linkKeys.forEach(k => keys.add(k)));
                return this.batchLinkOptions.filter(l => keys.has(`${l.payerId}|${l.linkId}`));
            },
        },
        methods:{
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            //获取列表
            getData(silent = false) {
                if (!silent) {
                    this.loadingPage = true;
                    this.loading = true;
                }
                this.formInline.link_id = (this.formInline.link_id || '').trim();
                console.time('[checkRebate] getData');
                getCheckRebateList(this.formInline).then(res => {
                    console.timeEnd('[checkRebate] getData');
                    this.loadingPage = false
                    this.loading = false;
                    if(res.code ==2000) {
                        this.tableData = res.data;
                        this.pageparm.page = res.page;
                        this.pageparm.limit = res.limit;
                        this.pageparm.total = res.total;
                    }else{
                        if (!silent) {
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    }
                }).catch(err => {
                    console.error('[checkRebate] getData error:', err);
                    this.loadingPage = false;
                    this.loading = false;
                })
            },
            permissionData(){
                this.getCustomersList();
                this.getLinksList();
                if(this.curRole=='admin'){
                    this.getAgentsList();
                    this.getSaleList();
                    this.getPayersList();
                }else if(this.curRole == 'sales'){
                    this.getAgentsList();
                    this.getPayersList();
                }else if(this.curRole == 'agent'){
                    // agent 角色批量修改弹窗也需要 agentsList（取自身那条 agent_id->payers 映射）
                    this.getAgentsList();
                    this.getPayersList();
                }
            },
            // 获取伙伴列表 - 使用store缓存
            async getAgentsList(){
                const billDataStore = useBillDataStore();
                if (billDataStore.loaded) {
                    this.agentsList = billDataStore.agents;
                } else {
                    const res = await getAgentList({company:'',payers:'',sales:'',page:1,limit:500});
                    if(res.code==2000){
                        this.agentsList = res.data.data;
                    }
                }
            },
            // 获取销售列表 - 使用store缓存
            async getSaleList(){
                const billDataStore = useBillDataStore();
                if (billDataStore.loaded) {
                    this.salesList = billDataStore.sales;
                } else {
                    const res = await getSalesList({name:'',phone:'',page:1,limit:100});
                    if(res.code==2000){
                        this.salesList = res.data.data;
                    }
                }
            },
            // 获取客户列表
            async getCustomersList(){
                const res = await getCustomerList({company:'',page:1,limit:500});
                if(res.code==2000){
                    this.customersList = res.data.data;
                }
            },
            // 获取payer列表 - 使用store缓存
            async getPayersList(){
                const billDataStore = useBillDataStore();
                if (billDataStore.loaded) {
                    this.payersList = billDataStore.payers;
                } else {
                    const res = await getPayerList({name:'',payer_id:'',region:'',page:1,limit:500});
                    if(res.code==2000){
                        this.payersList = res.data.data;
                    }
                }
            },
            // 获取link列表 - 使用store缓存
            async getLinksList(){
                const billDataStore = useBillDataStore();
                if (billDataStore.loaded) {
                    this.linksList = billDataStore.links;
                } else {
                    const res = await getLinkerList({page:1,limit:9999});
                    if(res && res.code==2000){
                        this.linksList = res.data.data || res.data || [];
                    }
                }
                this.displayedLinksList = this.linksList.slice(0, 50);
            },
            // link下拉框搜索
            linkFilterMethod(query){
                if(!query){
                    this.displayedLinksList = this.linksList.slice(0, 50);
                    return;
                }
                const q = query.trim();
                this.displayedLinksList = this.linksList.filter(item => {
                    return String(item.link_id).includes(q) ||
                           (item.customer_name && item.customer_name.includes(q)) ||
                           (item.name && item.name.includes(q));
                }).slice(0, 50);
            },
            // 如果到了截止日期，显示黄色，如果超过截止日期，显示红色
            tableRowClassName({row,rowIndex}){
                if(row.monthEnd){
                    if(Number(row.monthEnd.toString().substring(0,4)) == this.curYear &&Number(row.monthEnd.toString().substring(4,6)) == this.curMonth){
                        return 'yellow'
                    }else if(Number(row.monthEnd.toString().substring(0,4)) == this.curYear &&Number(row.monthEnd.toString().substring(4,6)) == (this.curMonth - 1)){
                        return 'red'
                    }
                }
            },
            // 排序接口
            sortChange({column,order}){
                if(column.label=='VAP返点'){
                    if(order=='ascending'){
                        this.formInline.orderby = 'discount1';
                    }else if(order=='descending'){
                        this.formInline.orderby = '-discount1';
                    }else{
                        this.formInline.orderby = '';
                    }
                }else{
                    if(order=='ascending'){
                        this.formInline.orderby = 'discount2';
                    }else if(order=='descending'){
                        this.formInline.orderby = '-discount2';
                    }else{
                        this.formInline.orderby = '';
                    }
                }
                this.search()
            },
            // 返点类型点击
            typeChange(val){
                if(val==1){
                    this.formInline.month = 0;
                    this.getData()
                }else{
                    this.formInline.month = this.curDate;
                    this.getData();
                }
            },
            // 关闭弹框
            cancel(){
                this.dialogVisible = false;
            },
            edit(row){
                this.formData = JSON.parse(JSON.stringify(row));
                this.formData.discount1 = Number(this.formData.discount1)*100;
                this.formData.discount2 = Number(this.formData.discount2)*100;
                this.formData.discount3 = Number(this.formData.discount3)*100;
                this.formData.sb_discount1 = Number((Number(this.formData.sb_discount1)*100).toFixed(2));
                this.formData.sb_discount2 = Number(this.formData.sb_discount2)*100;
                this.formData.sb_discount3 = Number(this.formData.sb_discount3)*100;
                this.dialogVisible = true;
                if(this.formInline.month == this.curDate){
                    this.formData.monthEnd = this.formData.monthEnd.toString().replace(/^(\d{4})(\d{2})$/, "$1-$2");
                }
            },
            submit(){
                // [2026-08-14] 因 202607 起系统 VAP 返点尚未 posted，放开「伙伴返点不能大于 VAP 返点」限制；「客户返点>伙伴返点」仍拦截。
                if(this.curRole!='agent'&&(Number(this.formData.discount3) > Number(this.formData.discount2))){
                    this.$message.warning('客户返点不能大于伙伴返点！');
                    return;
                }
                {
                    var obj = JSON.parse(JSON.stringify(this.formData));
                    obj.discount1 = Number(obj.discount1)/100;
                    obj.discount2 = Number(obj.discount2)/100;
                    obj.discount3 = Number(obj.discount3)/100;
                    obj.sb_discount1 = Number(obj.sb_discount1)/100;
                    obj.sb_discount2 = Number(obj.sb_discount2)/100;
                    obj.sb_discount3 = Number(obj.sb_discount3)/100;
                    if(obj.monthEnd.toString().indexOf('-')!=-1){
                        obj.monthEnd = Number(obj.monthEnd.split('-').join(''));
                    }else{
                        obj.monthEnd = Number(obj.monthEnd);
                    }
                    updateCheckRebate(obj).then(res=>{
                        if(res.code==2000){
                            this.dialogVisible = false;
                            this.$message.success('修改成功！');
                            this.getData();
                        }else{
                            this.$message.error('修改失败！');
                        }
                    })
                }
            },
            search() {
                this.formInline.page = 1
                this.formInline.limit = 16
                this.getData()
                localStorage.setItem('checkRebateForm',JSON.stringify(this.formInline));
            },
            reset(){
                this.formInline = {
                    month:0,
                    region:'',
                    sales:'',
                    agent_id:'',
                    payer_id:'',
                    link_id:'',
                    customer:'',
                    orderby:'',
                    page: 1,
                    limit: 16,
                }
                this.pageparm={
                    page: 1,
                    limit: 16,
                    total: 0
                }
                this.getData()
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            // 打开批量修改弹窗
            openBatchEdit() {
                this.resetBatchFormData();
                // 设置默认月份为页面选择的月份
                this.batchMonth = this.formInline.month;
                // 如果是agent角色，自动设置agent_id
                if (this.curRole === 'agent') {
                    this.batchSelectedAgent = localStorage.getItem('account');
                    this.onBatchAgentChange(this.batchSelectedAgent);
                }
                this.batchDialogVisible = true;
            },
            // 伙伴变化
            async onBatchAgentChange(agentId) {
                this.batchSelectedPayers = [];
                this.batchSelectedLinks = [];
                this.batchLinkOptions = [];
                this.batchCmaOptions = [];
                this.batchSelectedCmas = [];
                this.batchCmaReqSeq++;
                if (!agentId) {
                    this.batchPayerOptions = [];
                    return;
                }
                // 获取该伙伴下的payer
                const agent = this.agentsList.find(a => a.agent_id === agentId);
                if (agent && agent.payers) {
                    const payerIds = agent.payers.split(',').map(id => id.trim());
                    this.batchPayerOptions = this.payersList.filter(p => payerIds.includes(p.payer_id));
                }
            },
            // payer变化
            async onBatchPayerChange(autoSelectLinks = false) {
                this.batchSelectedLinks = [];
                this.batchSelectAllLinks = false;
                this.batchSelectedCmas = [];
                this.batchCmaOptions = [];
                this.batchLastMonthData = { discount2: '', discount3: '', sb_discount2: '', sb_discount3: '' };
                if (!this.batchSelectedPayers.length) {
                    this.batchLinkOptions = [];
                    return;
                }
                // 获取选中payer下的link，使用弹窗的月份
                const promises = this.batchSelectedPayers.map(payerId => {
                    return getCheckRebateList({
                        agent_id: this.batchSelectedAgent,
                        payer_id: payerId,
                        month: this.batchMonth,
                        page: 1,
                        limit: 9999
                    });
                });
                const results = await Promise.all(promises);
                this.batchLinkOptions = [];
                results.forEach(res => {
                    if (res.code === 2000 && res.data) {
                        this.batchLinkOptions = this.batchLinkOptions.concat(res.data);
                    }
                });
                
                // 如果是全选Payer触发的，自动全选Link
                if (autoSelectLinks && this.batchLinkOptions.length > 0) {
                    this.batchSelectedLinks = this.batchLinkOptions.map(link => link.linkId);
                    this.batchSelectAllLinks = true;
                    this.updateBatchLastMonthData();
                }
                await this.loadBatchCmaOptions();
            },
            // 选中 payer 中的 BT payer -> 二代PMA自有树 / CMA 树分组；非 BT payer 后端不返回分组，区域自动隐藏
            async loadBatchCmaOptions() {
                const seq = ++this.batchCmaReqSeq;
                const payerIds = [...this.batchSelectedPayers];
                if (!payerIds.length || !this.batchLinkOptions.length) {
                    this.batchCmaOptions = [];
                    return;
                }
                let groups = [];
                try {
                    const res = await getBtGroups({ payer_ids: payerIds.join(','), month: this.batchMonth || '' });
                    if (res.code === 2000 && Array.isArray(res.data)) {
                        groups = res.data;
                    }
                } catch (e) {
                    console.error('获取CMA分组失败:', e);
                }
                if (seq !== this.batchCmaReqSeq) return; // payer 又变了，丢弃过期结果
                const loaded = new Set(this.batchLinkOptions.map(l => `${l.payerId}|${l.linkId}`));
                const multiPayer = payerIds.length > 1;
                this.batchCmaOptions = groups.map(g => {
                    const linkKeys = (g.link_ids || []).map(id => `${g.payer_id}|${id}`).filter(k => loaded.has(k));
                    const name = g.kind === 'pma' ? (g.partner || '二代PMA') : `${g.partner ? g.partner + ' / ' : ''}${g.cma_name || g.source}`;
                    return {
                        key: `${g.payer_id}|${g.kind}|${g.source}`,
                        kind: g.kind,
                        label: `${multiPayer ? g.payer_name + ' · ' : ''}${name}（${g.source}）· ${linkKeys.length}个Link`,
                        linkKeys,
                    };
                }).filter(g => g.linkKeys.length > 0);
            },
            // CMA 变化：下方 Link 列表收窄到所选 CMA，并默认全部选中；不选 CMA 恢复全部 Link、清空选择
            onBatchCmaChange() {
                const visible = this.batchVisibleLinkOptions;
                if (this.batchSelectedCmas.length) {
                    this.batchSelectedLinks = visible.map(l => l.linkId);
                    this.batchSelectAllLinks = visible.length > 0;
                } else {
                    this.batchSelectedLinks = [];
                    this.batchSelectAllLinks = false;
                }
                this.updateBatchLastMonthData();
            },
            // 全选payer
            onSelectAllPayers(val) {
                if (val) {
                    this.batchSelectedPayers = this.batchPayerOptions.map(payer => payer.payer_id);
                } else {
                    this.batchSelectedPayers = [];
                }
                // 传入true表示是全选Payer触发的，需要自动全选Link
                this.onBatchPayerChange(val);
            },
            // 全选link（选了CMA时只在该CMA范围内全选）
            onSelectAllLinks(val) {
                if (val) {
                    this.batchSelectedLinks = this.batchVisibleLinkOptions.map(link => link.linkId);
                } else {
                    this.batchSelectedLinks = [];
                }
                this.updateBatchLastMonthData();
            },
            // 更新上月数据
            updateBatchLastMonthData() {
                if (this.batchSelectedLinks.length === 1) {
                    const link = this.batchLinkOptions.find(l => l.linkId === this.batchSelectedLinks[0]);
                    if (link) {
                        this.batchLastMonthData = {
                            discount2: (Number(link.discount2) * 100).toFixed(1),
                            discount3: (Number(link.discount3) * 100).toFixed(1),
                            sb_discount2: (Number(link.sb_discount2) * 100).toFixed(1),
                            sb_discount3: (Number(link.sb_discount3) * 100).toFixed(1),
                        };
                        this.batchFormData.discount1 = (Number(link.discount1) * 100).toFixed(1);
                        this.batchFormData.credit = Number(link.credit) || 0;
                        this.batchFormData.ri = Number(link.ri) || 0;
                        this.batchFormData.sp = Number(link.sp) || 0;
                        this.batchFormData.bundle = Number(link.bundle) || 0;
                    }
                } else if (this.batchSelectedLinks.length > 1) {
                    const firstLink = this.batchLinkOptions.find(l => l.linkId === this.batchSelectedLinks[0]);
                    if (firstLink) {
                        this.batchFormData.discount1 = (Number(firstLink.discount1) * 100).toFixed(1);
                    }
                    this.batchLastMonthData = { discount2: '', discount3: '', sb_discount2: '', sb_discount3: '' };
                    this.batchFormData.credit = -1;
                    this.batchFormData.ri = -1;
                    this.batchFormData.sp = -1;
                    this.batchFormData.bundle = -1;
                } else {
                    this.batchFormData.discount1 = '';
                    this.batchLastMonthData = { discount2: '', discount3: '', sb_discount2: '', sb_discount3: '' };
                    this.batchFormData.credit = -1;
                    this.batchFormData.ri = -1;
                    this.batchFormData.sp = -1;
                    this.batchFormData.bundle = -1;
                }
            },
            // 处理留利变化，自动计算伙伴返点
            handleAgentProfitChange(value) {
                this.batchFormData.agentProfit = value.replace(/[^\d.]/g, '');

                if (this.batchFormData.agentProfit && this.batchFormData.discount1) {
                    const vapDiscount = parseFloat(this.batchFormData.discount1);
                    const profit = parseFloat(this.batchFormData.agentProfit);

                    if (!isNaN(vapDiscount) && !isNaN(profit)) {
                        const agentDiscount = vapDiscount - profit;
                        this.batchFormData.discount2 = agentDiscount >= 0 ? agentDiscount.toFixed(1) : '0.0';
                    }
                } else {
                    this.batchFormData.discount2 = '';
                }
            },
            // 应用留利设置
            async applyAgentProfit() {
                if (!this.batchSelectedAgent) {
                    this.$message.warning('请选择伙伴');
                    return;
                }
                if (!this.batchMonth) {
                    this.$message.warning('请选择月份');
                    return;
                }
                if (!this.batchFormData.agentProfit) {
                    this.$message.warning('请输入佳杰留利');
                    return;
                }

                this.batchSubmitting = true;
                try {
                    // 生成从当前月份开始的12个月份
                    const startMonth = parseInt(this.batchMonth);
                    const months = [startMonth];
                    let year = Math.floor(startMonth / 100);
                    let month = startMonth % 100;

                    for (let i = 0; i < 11; i++) {
                        month++;
                        if (month > 12) {
                            month = 1;
                            year++;
                        }
                        months.push(year * 100 + month);
                    }

                    const updatePromises = [];

                    for (const targetMonth of months) {
                        // 构建查询条件
                        const query = {
                            agent_id: this.batchSelectedAgent,
                            month: targetMonth,
                            page: 1,
                            limit: 9999
                        };

                        let allConfigs = [];
                        if (this.batchSelectedPayers.length > 0) {
                            for (const payerId of this.batchSelectedPayers) {
                                const res = await getCheckRebateList({
                                    ...query,
                                    payer_id: payerId
                                });
                                if (res.code === 2000 && res.data) {
                                    allConfigs = allConfigs.concat(res.data);
                                }
                            }
                        } else {
                            const res = await getCheckRebateList(query);
                            if (res.code === 2000 && res.data) {
                                allConfigs = res.data;
                            }
                        }

                        for (const link of allConfigs) {
                            const obj = JSON.parse(JSON.stringify(link));
                            obj.agent_profit = Number(this.batchFormData.agentProfit) / 100;
                            obj.discount2 = Math.max(0, Number(obj.discount1) - Number(this.batchFormData.agentProfit) / 100);

                            if (obj.monthEnd && obj.monthEnd.toString().indexOf('-') !== -1) {
                                obj.monthEnd = Number(obj.monthEnd.split('-').join(''));
                            } else {
                                obj.monthEnd = Number(obj.monthEnd);
                            }

                            updatePromises.push({ label: `${link.linkId}(${targetMonth})`, obj });
                        }
                    }

                    if (updatePromises.length === 0) {
                        this.$message.warning('没有找到需要更新的配置');
                        return;
                    }

                    const { successCount, failed } = await this.runBatchUpdates(updatePromises);

                    if (!failed.length) {
                        this.$message.success(`留利设置成功！已更新${successCount}条配置，今后会沿用此配置`);
                        this.getData();
                    } else {
                        this.showBatchFailed(successCount, failed);
                    }
                } catch (error) {
                    this.$message.error('留利设置失败:' + error.message);
                } finally {
                    this.batchSubmitting = false;
                }
            },
            // 批量保存：限流并发，每个保存请求后端都会重新出账，全量并发会把浏览器和服务器挤爆
            async runBatchUpdates(items, limit = 4) {
                this.batchProgress = { done: 0, total: items.length, failed: 0 };
                const failed = [];
                let successCount = 0;
                let next = 0;
                const worker = async () => {
                    while (next < items.length) {
                        const item = items[next++];
                        try {
                            const res = await updateCheckRebate(item.obj);
                            if (res && res.code === 2000) {
                                successCount++;
                            } else {
                                failed.push(`${item.label}：${(res && res.msg) || '保存失败'}`);
                            }
                        } catch (e) {
                            failed.push(`${item.label}：${e.message || '请求失败'}`);
                        }
                        this.batchProgress = { ...this.batchProgress, done: this.batchProgress.done + 1, failed: failed.length };
                    }
                };
                await Promise.all(Array.from({ length: Math.min(limit, items.length) }, worker));
                return { successCount, failed };
            },
            showBatchFailed(successCount, failed) {
                const lines = failed.slice(0, 30).map(t => h('div', t));
                if (failed.length > 30) lines.push(h('div', `……共 ${failed.length} 条`));
                this.$alert(h('div', { style: 'max-height: 320px; overflow-y: auto;' }, [
                    h('div', { style: 'margin-bottom: 8px;' }, `成功 ${successCount} 条，失败 ${failed.length} 条，可只选失败的 Link 重新提交：`),
                    ...lines,
                ]), '部分保存失败', { confirmButtonText: '知道了' });
                this.getData();
            },
            // 重置批量修改表单
            resetBatchFormData() {
                this.batchSelectedAgent = '';
                this.batchSelectedPayers = [];
                this.batchSelectAllPayers = false;
                this.batchSelectedLinks = [];
                this.batchSelectAllLinks = false;
                this.batchPayerOptions = [];
                this.batchLinkOptions = [];
                this.batchCmaOptions = [];
                this.batchSelectedCmas = [];
                this.batchCmaReqSeq++;
                this.batchMonth = '';
                this.batchLastMonthData = {
                    discount2: '',
                    discount3: '',
                    sb_discount2: '',
                    sb_discount3: '',
                };
                this.batchFormData = {
                    discount1: '',
                    agentProfit: '',
                    discount2: '',
                    discount3: '',
                    sb_discount2: '',
                    sb_discount3: '',
                    credit: -1,
                    ri: -1,
                    sp: -1,
                    bundle: -1,
                };
            },
            // 取消批量修改
            cancelBatch() {
                this.batchDialogVisible = false;
                this.resetBatchFormData();
            },
            // 提交批量修改
            async submitBatch() {
                // 如果设置了留利，则不需要选择Link
                if (!this.batchFormData.agentProfit) {
                    if (!this.batchSelectedLinks.length) {
                        this.$message.warning('请选择要修改的Link');
                        return;
                    }
                }
                if (!this.batchMonth) {
                    this.$message.warning('请选择月份');
                    return;
                }
                if (!this.batchFormData.discount2 && !this.batchFormData.discount3 &&
                    !this.batchFormData.sb_discount2 && !this.batchFormData.sb_discount3 &&
                    !this.batchFormData.agentProfit &&
                    this.batchFormData.credit === -1 && this.batchFormData.ri === -1 &&
                    this.batchFormData.sp === -1 && this.batchFormData.bundle === -1) {
                    this.$message.warning('请至少修改一项内容');
                    return;
                }

                this.batchSubmitting = true;
                try {
                    const targetLinks = this.batchLinkOptions.filter(link => this.batchSelectedLinks.includes(link.linkId));
                    const updatePromises = [];
                    const setDefault = (this.curRole === 'admin' || this.curRole === 'sales') && this.batchFormData.agentProfit;
                    // 默认配置必须用该 link 自己的 month=0 记录；用当月记录 id 提交 month=0 会把当月配置改成默认配置
                    const defaultMap = {};
                    if (setDefault) {
                        const payerIds = [...new Set(targetLinks.map(l => l.payerId))];
                        for (const payerId of payerIds) {
                            const res = await getCheckRebateList({ agent_id: this.batchSelectedAgent, payer_id: payerId, month: 0, page: 1, limit: 9999 });
                            if (res.code === 2000 && res.data) {
                                res.data.filter(d => Number(d.month) === 0).forEach(d => { defaultMap[`${d.linkId}|${d.payerId}`] = d; });
                            }
                        }
                    }

                    for (const link of targetLinks) {
                        const obj = JSON.parse(JSON.stringify(link));
                        obj.month = Number(this.batchMonth);

                        // VAP 设定的字段：discount1/discount2/sb_discount2/agent_profit
                        // agent(伙伴) 角色禁止改动这 4 项；只有 admin/sales 才会进入下方逻辑
                        if (this.curRole === 'admin' || this.curRole === 'sales') {
                            if (this.batchFormData.agentProfit) {
                                obj.agent_profit = Number(this.batchFormData.agentProfit) / 100;
                                obj.discount2 = Math.max(0, Number(obj.discount1) - Number(this.batchFormData.agentProfit) / 100);
                            } else {
                                obj.agent_profit = null;
                                if (this.batchFormData.discount2) {
                                    obj.discount2 = Number(this.batchFormData.discount2) / 100;
                                }
                            }
                            if (this.batchFormData.sb_discount2) obj.sb_discount2 = Number(this.batchFormData.sb_discount2) / 100;
                        }
                        // 注：agent 角色 obj.discount1/discount2/sb_discount2/agent_profit 保留 link 原值，
                        //     后端 ViewSet_BillConfig.update 还会再做一次 userType==2 兜底覆盖

                        if (this.batchFormData.discount3) obj.discount3 = Number(this.batchFormData.discount3) / 100;
                        if (this.batchFormData.sb_discount3) obj.sb_discount3 = Number(this.batchFormData.sb_discount3) / 100;
                        if (this.batchFormData.credit !== -1) obj.credit = this.batchFormData.credit;
                        if (this.batchFormData.ri !== -1) obj.ri = this.batchFormData.ri;
                        if (this.batchFormData.sp !== -1) obj.sp = this.batchFormData.sp;
                        if (this.batchFormData.bundle !== -1) obj.bundle = this.batchFormData.bundle;

                        if (obj.monthEnd && obj.monthEnd.toString().indexOf('-') !== -1) {
                            obj.monthEnd = Number(obj.monthEnd.split('-').join(''));
                        } else {
                            obj.monthEnd = Number(obj.monthEnd);
                        }

                        updatePromises.push({ label: `${link.linkId}(${obj.month})`, obj });

                        // 同时更新默认配置（month=0），仅 admin/sales 设置留利时触发
                        const defaultRow = setDefault && defaultMap[`${link.linkId}|${link.payerId}`];
                        if (defaultRow) {
                            const defaultObj = JSON.parse(JSON.stringify(link));
                            defaultObj.id = defaultRow.id;
                            defaultObj.month = 0;
                            defaultObj.agent_profit = Number(this.batchFormData.agentProfit) / 100;
                            defaultObj.discount2 = Math.max(0, Number(defaultObj.discount1) - Number(this.batchFormData.agentProfit) / 100);

                            if (defaultObj.monthEnd && defaultObj.monthEnd.toString().indexOf('-') !== -1) {
                                defaultObj.monthEnd = Number(defaultObj.monthEnd.split('-').join(''));
                            } else {
                                defaultObj.monthEnd = Number(defaultObj.monthEnd);
                            }

                            updatePromises.push({ label: `${link.linkId}(默认配置)`, obj: defaultObj });
                        }
                    }

                    const { successCount, failed } = await this.runBatchUpdates(updatePromises);

                    if (!failed.length) {
                        this.$message.success(`批量修改成功！已更新 ${successCount} 条配置`);
                        this.batchDialogVisible = false;
                        this.getData();
                    } else {
                        this.showBatchFailed(successCount, failed);
                    }
                } catch (error) {
                    this.$message.error('批量修改失败：' + error.message);
                } finally {
                    this.batchSubmitting = false;
                }
            },
            formatMonth(month) {
                if (!month) return '';
                const str = month.toString();
                return `${str.substring(0, 4)}-${str.substring(4, 6)}`;
            },
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                this.$nextTick(() => {
                    const windowHeight = window.innerHeight;
                    const tableSelectHeight = this.$refs.tableSelect ? this.$refs.tableSelect.offsetHeight : 100;
                    // 窗口高度 - 顶部导航(60) - 搜索栏 - 分页(60) - 边距(50)
                    this.tableHeight = windowHeight - 60 - tableSelectHeight - 60 - 50;
                });
            },
        },
        created() {
            let date = new Date();
            let endY =date.getFullYear();
            let endM = (date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1 ) : date.getMonth()+1);
            this.curDate = endY.toString()+endM.toString();
            this.formInline.month = this.curDate;
            if(localStorage.getItem('checkRebateForm')){
                this.formInline = JSON.parse(localStorage.getItem('checkRebateForm'));
            }
            if(this.curRole=='sales'){
                this.formInline.sales = localStorage.getItem('account');
            }else if(this.curRole == 'agent'){
                this.formInline.agent_id = localStorage.getItem('account');
            }
            this.permissionData();
        },
        activated() {
            this.permissionData();
            if (!this.isDataLoaded) {
                this.getData();
                this.isDataLoaded = true;
            }
        },
        mounted() {
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },


        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>

<style lang="scss">
.checkRebate{
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .tableSelect{
        flex-shrink: 0;
    }

    .batch-actions{
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 15px;
        background: #f5f7fa;
        border-bottom: 1px solid #ebeef5;

        .el-button{
            .el-icon{
                margin-right: 4px;
            }
        }
    }

    .table-wrapper{
        flex: 1;
        display: flex;
        flex-direction: column;

        .table{
            flex: 0 0 auto;
        }

        .pagination-wrapper{
            flex-shrink: 0;
            padding: 15px 0;
            background: #fff;
            border-top: 1px solid #ebeef5;
            min-height: 60px;
        }
    }

    .el-dialog{
        .el-col-8{
            max-width:calc(33.333333% - 40px);
            flex:0 0 0 calc(33.333333% - 40px);
            margin:0 20px;
        }
    }
    .table{
        .el-table tr.red{
            background: #f56c6c;
            color: #fff;
            td.el-table__cell{
                background: #f56c6c;
                color: #fff;
                .cell{
                    .el-button.is-link{
                        color: #cde5ff;
                    }
                }
            }
        }
        .el-table tr.yellow{
            background-color:#f5e56c;
            td.el-table__cell{
                background-color:#f5e56c;
            }
        }
    }

    .btn-search-dark {
        background: #1a1a2e;
        border-color: #1a1a2e;
        color: #fff;
        border-radius: 8px;
        &:hover { background: #374151; border-color: #374151; color: #fff; }
    }

}
</style>
